import React, { useEffect } from 'react';
import './App.css';
import profilePic from './assets/profile.jpg';

function App() {
  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth) * 100;
      const y = (e.clientY / window.innerHeight) * 100;
      document.body.style.setProperty('--mouse-x', `${x}%`);
      document.body.style.setProperty('--mouse-y', `${y}%`);

      const cursor = document.getElementById('custom-cursor');
      if (cursor) {
        cursor.style.left = `${e.clientX}px`;
        cursor.style.top = `${e.clientY}px`;
      }
    };

    window.addEventListener('mousemove', handleMouseMove);

    const observerOptions = {
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal');
        }
      });
    }, observerOptions);

    document.querySelectorAll('section').forEach((section) => {
      observer.observe(section);
      section.classList.add('hidden-section');
    });

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      observer.disconnect();
    };
  }, []);

  const projects = [
    {
      title: "NorthStar Connect",
      description: "A comprehensive remote management application for home security and smart home automation, featuring remote arming, smart device control, and real-time video monitoring.",
      tech: ["React Native", "IoT Integration", "Smart Home"],
      link: "https://play.google.com/store/apps/details?id=com.northstar.connect&hl=en_IN&pli=1"
    },
    {
      title: "Sell My Rig: Equipment Finance",
      description: "A specialized equipment finance marketplace application designed to streamline deal closures and improve business efficiency.",
      tech: ["React Native", "iOS", "Financial Services"],
      link: "https://apps.apple.com/us/app/sell-my-rig-equipment-finance/id6749225803"
    },
    {
      title: "Worker Diary App",
      description: "Finance tracking application for workers to manage daily expenses, rewards, and points.",
      tech: ["React Native", "Firebase", "Redux"],
      link: "https://play.google.com/store/apps/details?id=com.workerdiary.app"
    },
    {
      title: "FBINS App",
      description: "Insurance claim application to digitize paperwork, supporting multiple claim forms and payment methods.",
      tech: ["React Native", "REST API", "Payment Gateway"],
      link: "https://play.google.com/store/apps/details?id=com.fbfs.mobile&pli=1"
    },
    {
      title: "Habit Better App",
      description: "Health application for goal tracking, video courses, and coach collaboration.",
      tech: ["React Native", "Video Processing", "Goal Tracking"],
      link: "https://habitbetter.com/app/"
    },
    {
      title: "Conference Coco",
      description: "Professional tool for conference tracking with image editing and interactive charts.",
      tech: ["React Native", "D3.js", "Camera API"],
    },
    {
      title: "Agramaark Web App",
      description: "Empowering rural livelihoods with dignity. From field to market, Agramaark connects smallholder farmers, SHGs, and FPOs to responsible buyers through ethical sourcing and transparent trade.",
      tech: ["React", "Supply Chain", "Ethical Sourcing"],
      link: "https://agramaark.com/"
    },
    {
      title: "MGPL Web App",
      description: "React web application for social awareness regarding women empowerment.",
      tech: ["React", "CSS3", "Responsive Design"],
      link: "https://mgpl.agramaark.com/"
    },
    {
      title: "Alatun App",
      description: "Logistics application specifically designed for ships and container management companies.",
      tech: ["React Native", "Google Maps", "API Integration"],
    }
  ];

  const experience = [
    {
      role: "Frontend Developer",
      company: "Prescient Healthcare Group",
      location: "Gurgaon (Remote)",
      duration: "12/2024 - 12/2025",
      points: [
        "Focused on React Native UI development and API integrations.",
        "Implemented secure payment gateways and iOS-specific optimizations."
      ]
    },
    {
      role: "Frontend Developer",
      company: "Radiansys Pvt Ltd",
      location: "Gurgaon",
      duration: "01/2022 - 12/2024",
      points: [
        "Integrated RESTful APIs to enhance app functionality and user experience.",
        "Conducted thorough testing and debugging to ensure application reliability across platforms."
      ]
    },
    {
      role: "Frontend Developer",
      company: "eFaarms solution Pvt Ltd",
      location: "Banglore",
      duration: "07/2021 - 12/2021",
      points: [
        "Collaborated with cross-functional teams to define, design, and ship new features.",
        "Optimized application performance by implementing best coding practices and reusable components."
      ]
    },
  ];

  const skills = ["React Native", "React Js", "JavaScript (ES6+)", "Redux", "TypeScript", "Hybrid Apps", "Python", "iOS/Android Dev", "REST APIs"];
  const learning = ["Node.js", "Express", "Backend Development"];

  return (
    <div className="App">
      <div id="custom-cursor" className="custom-cursor"></div>
      <div className="mesh-gradient"></div>
      <nav>
        <div className="logo"><span className="gradient-text">HIMANSHU SINGH</span></div>
        <div className="nav-links">
          <a href="#about">About</a>
          <a href="#projects">Work</a>
          <a href="#experience">Experience</a>
          <a href="#contact">Contact</a>
        </div>
      </nav>

      <section className="hero" id="about">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="gradient-text">Himanshu Singh</h1>
            <h3 style={{ fontSize: '1.8rem', color: 'var(--accent-secondary)', marginTop: '-1rem', marginBottom: '1.5rem' }}>
              Frontend Developer
            </h3>
            <p>
              Frontend Engineer with 4.8 years of experience in building intuitive, scalable, and high-performance web and mobile applications using React, React Native, and modern JavaScript frameworks. Strong expertise in developing responsive UI architectures, optimizing application performance, and delivering seamless user experiences. Experienced in integrating AI-driven features and APIs into frontend applications to create intelligent, data-driven solutions. Proven ability to translate complex business requirements into efficient, maintainable, and innovative technical implementations.
            </p>
            <div className="hero-btns">
              <button className="cta-button" onClick={() => document.getElementById('projects').scrollIntoView()}>View Projects</button>
              <button className="cta-button" style={{ background: 'transparent', border: '1px solid var(--accent-primary)' }}
                onClick={() => window.open('https://github.com/hmnshsingh228', '_blank')}>
                GitHub
              </button>
              <a
                href="https://in.linkedin.com/in/himanshu-singh-772b8b1a0"
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button"
                style={{
                  background: "transparent",
                  border: "1px solid var(--accent-primary)",
                  padding: "15px 30px",
                  display: "inline-block",
                  textDecoration: "none"
                }}
              >
                LinkedIn
              </a>
            </div>
          </div>
          <div className="profile-container">
            <img src={profilePic} alt="Himanshu Singh" className="profile-img" />
          </div>
        </div>
      </section>

      <section id="skills">
        <h2 style={{ fontSize: '3rem', marginBottom: '3rem', textAlign: 'center' }}>Tech Stack</h2>
        <div className="skills-container" style={{ marginBottom: '5rem' }}>
          {skills.map((skill, index) => (
            <div key={index} className="glass-card skill-box">
              {skill}
            </div>
          ))}
        </div>

        <h2 style={{ fontSize: '3rem', marginBottom: '3rem', textAlign: 'center' }}>Learning New Skills</h2>
        <div className="skills-container">
          {learning.map((skill, index) => (
            <div key={index} className="glass-card skill-box" style={{ border: '1px solid var(--accent-secondary)' }}>
              {skill}
            </div>
          ))}
        </div>
      </section>

      <section id="experience">
        <h2 style={{ fontSize: '3rem', marginBottom: '3rem' }}>Work Journey</h2>
        <div className="experience-list">
          {experience.map((exp, index) => (
            <div key={index} className="glass-card exp-card">
              <div className="exp-header">
                <div>
                  <h3>{exp.role}</h3>
                  <p className="gradient-text" style={{ fontWeight: 600 }}>{exp.company} • {exp.location}</p>
                </div>
                <span className="duration-tag">{exp.duration}</span>
              </div>
              <ul className="exp-points">
                {exp.points.map((pt, i) => (
                  <li key={i}>{pt}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section id="projects">
        <h2 style={{ fontSize: '3rem', marginBottom: '2rem' }}>Selected Projects</h2>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="glass-card project-card" onClick={() => project.link && window.open(project.link, '_blank')}>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="tech-stack">
                {project.tech.map((t, i) => (
                  <span key={i} className="tech-tag">{t}</span>
                ))}
              </div>
              {project.link && <span className="view-link">View Project →</span>}
            </div>
          ))}
        </div>
      </section>

      <section id="education">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
          <div className="glass-card" style={{ padding: '3rem', textAlign: 'center' }}>
            <h2 className="gradient-text">Master's Degree</h2>
            <h3 style={{ marginTop: '1rem' }}>MCA: Computers</h3>
            <p>Vellore Institute of Technology (VIT) - Chennai</p>
            <p style={{ color: 'var(--accent-tertiary)', fontWeight: 700, fontSize: '1.2rem' }}>GPA: 8/10 • Graduated 2021</p>
          </div>
          <div className="glass-card" style={{ padding: '3rem', textAlign: 'center' }}>
            <h2 className="gradient-text">Bachelor's Degree</h2>
            <h3 style={{ marginTop: '1rem' }}>BCA</h3>
            <p>Mahatma Gandhi Kashi Vidyapith (MGKVP) - Varanasi</p>
            <p style={{ color: 'var(--accent-tertiary)', fontWeight: 700, fontSize: '1.2rem' }}>Score: 68%</p>
          </div>
        </div>
      </section>

      <section id="contact">
        <div className="contact-content">
          <h2 style={{ fontSize: '4rem', marginBottom: '1.5rem' }} className="gradient-text">Get In Touch</h2>
          <p style={{ fontSize: '1.2rem', marginBottom: '1rem', color: '#fff' }}>Gurgaon, India • 8318710946</p>
          <p style={{ fontSize: '1.5rem', marginBottom: '3rem', color: '#a0a0a0' }}>
            Available for new opportunities in React Native & Frontend Development.
          </p>
          <div className="contact-links">
            <a href="mailto:hmnshsingh228@gmail.com" className="contact-link">Email</a>
            <a href="https://github.com/hmnshsingh228" target="_blank" rel="noreferrer" className="contact-link">GitHub</a>
            <a href="https://in.linkedin.com/in/himanshu-singh-772b8b1a0/" target="_blank" rel="noreferrer" className="contact-link">LinkedIn</a>
          </div>
        </div>
      </section>

      <footer style={{ padding: '4rem', textAlign: 'center', borderTop: '1px solid var(--glass-border)' }}>
        <p style={{ color: '#666' }}>© 2026 Himanshu Singh • React Native Expert</p>
      </footer>
    </div>
  );
}

export default App;
